// import components
import Hero from "../components/Hero.jsx";
import CategoryShowcase from "../components/CategoryShowcase.jsx";
import LatestProducts from "../components/LatestProducts.jsx";
import PromoBand from "../components/PromoBand.jsx";
import Brands from "../components/Brands.jsx";
import TrustBadges from "../components/TrustBadges.jsx";

export default function Home() {
  return (
    <div>
      <Hero />
      <CategoryShowcase />
      <LatestProducts />
      <PromoBand />
      <Brands />
      <TrustBadges />
    </div>
  );
}
